import { PlanContext } from "../../context"
import { saveField } from "../../state"
import { PlanState } from "../../types"

interface Props {
    state: PlanState
}

export function Commands({ state, state: { selectedField: field } }: Props) {

    const { dispatch, api } = React.useContext(PlanContext)

    if (!field) {
        return null
    }

    const disabled = !field.updated
    const canSave = (!disabled) && field.valid

    const cancel = () => dispatch({ type: "cancelChanges" })

    const save = () => saveField(state, dispatch, api)

    return <div className="commands">

        <button type="button" className="btn btn-warning" onClick={cancel} disabled={disabled}>
            Cancel
        </button>

        <button type="button" className="btn btn-success" disabled={!canSave} onClick={save}>
            Save
        </button>

    </div>

}
